import {BaseService} from './Core/BaseService';

class ContextService extends BaseService {
    get Url() { return super.Url + "/context"; }

    GetContext(context) {
        return this.SendRequest(BaseService.GET, context);
    }
}

export const service = new ContextService();

